const currentDate = new Date();
export const currentTime = currentDate.toLocaleTimeString();
export const formattedDate = currentDate.toISOString().slice(0, 10);